import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";
import { BankAccountTransactions } from "./BankAccountTransactions";


export class SetTransactionStateErrorToDraftCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly q_dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(transaction_ids:[string], bank_account_id:string|number, listFilters?): Promise<any> {
    let args = { 
      transaction_ids: transaction_ids,
      bank_account_id: bank_account_id
    }
    try {
      //this.frontend.loading_update_counterpart(true)
      await this.dispatcher.dispatch('set.transaction.state.error.to.draft', args)
      await new BankAccountTransactions(this.q_dispatcher, this.frontend).run_filter(bank_account_id, listFilters, this.frontend.$refs.bankSimpleFilters.option_selected, this.frontend.limit, this.frontend.offset)      
    } catch (error) {
      console.error('Error update transactions state to draft', error)
    }
  }
}